/** The two-letter USPS state, territory and military codes. */
export var UsState;
(function (UsState) {
    UsState["AA"] = "AA";
    UsState["AE"] = "AE";
    UsState["AK"] = "AK";
    UsState["AL"] = "AL";
    UsState["AP"] = "AP";
    UsState["AR"] = "AR";
    UsState["AS"] = "AS";
    UsState["AZ"] = "AZ";
    UsState["CA"] = "CA";
    UsState["CO"] = "CO";
    UsState["CT"] = "CT";
    UsState["DC"] = "DC";
    UsState["DE"] = "DE";
    UsState["FL"] = "FL";
    UsState["FM"] = "FM";
    UsState["GA"] = "GA";
    UsState["GU"] = "GU";
    UsState["HI"] = "HI";
    UsState["IA"] = "IA";
    UsState["ID"] = "ID";
    UsState["IL"] = "IL";
    UsState["IN"] = "IN";
    UsState["KS"] = "KS";
    UsState["KY"] = "KY";
    UsState["LA"] = "LA";
    UsState["MA"] = "MA";
    UsState["MD"] = "MD";
    UsState["ME"] = "ME";
    UsState["MH"] = "MH";
    UsState["MI"] = "MI";
    UsState["MN"] = "MN";
    UsState["MO"] = "MO";
    UsState["MP"] = "MP";
    UsState["MS"] = "MS";
    UsState["MT"] = "MT";
    UsState["NC"] = "NC";
    UsState["ND"] = "ND";
    UsState["NE"] = "NE";
    UsState["NH"] = "NH";
    UsState["NJ"] = "NJ";
    UsState["NM"] = "NM";
    UsState["NV"] = "NV";
    UsState["NY"] = "NY";
    UsState["OH"] = "OH";
    UsState["OK"] = "OK";
    UsState["OR"] = "OR";
    UsState["PA"] = "PA";
    UsState["PR"] = "PR";
    UsState["PW"] = "PW";
    UsState["RI"] = "RI";
    UsState["SC"] = "SC";
    UsState["SD"] = "SD";
    UsState["TN"] = "TN";
    UsState["TX"] = "TX";
    UsState["UT"] = "UT";
    UsState["VA"] = "VA";
    UsState["VI"] = "VI";
    UsState["VT"] = "VT";
    UsState["WA"] = "WA";
    UsState["WI"] = "WI";
    UsState["WV"] = "WV";
    UsState["WY"] = "WY";
})(UsState || (UsState = {}));
//# sourceMappingURL=usState.js.map